import { useCallback, useEffect, useState } from 'react';
import { useVideo } from '../../context/videoContext';
import { usePostMessage } from '../../context/messageContext';

const useVideoRecording = () => {
  const [videoTracks, setVideoTracks] = useState(null);
  const [videoRecorder, setVideoRecorder] = useState(null);
  const { participants } = useVideo();
  const postMessage = usePostMessage();

  const trackpubsToTracks = (trackMap) =>
    Array.from(trackMap.values())
      .map((publication) => publication.track)
      .filter((track) => track !== null);

  useEffect(() => {
    if (participants) setVideoTracks(trackpubsToTracks(participants.videoTracks));
  }, [participants]);

  useEffect(() => {
    if (videoTracks) {
      const videoStream = new MediaStream([videoTracks[0]?.mediaStreamTrack]);
      setVideoRecorder(new MediaRecorder(videoStream));
    }
  }, [videoTracks]);

  useEffect(() => {
    if (videoRecorder)
      videoRecorder.addEventListener('dataavailable', (e) => {
        const videoUrl = URL.createObjectURL(e.data);
        postMessage({ type: 'videoRecordingData', content: videoUrl });
      });
  }, [videoRecorder, postMessage]);

  const startRecording = useCallback(() => {
    if (videoRecorder) return videoRecorder.start();
    return console.error('Patient video not available at this time.');
  }, [videoRecorder]);

  const stopRecording = useCallback(() => {
    if (videoRecorder) return videoRecorder.stop();
    return console.error('Patient video not available at this time.');
  }, [videoRecorder]);

  return { startRecording, stopRecording, videoRecorder };
};

export default useVideoRecording;
